
  import MainPage from "../components/views/MainPageView";

  export default {
    name: 'IndexPage',
    components: {MainPage},
    // layout: 'main',

  }
